module.exports = __webpack_public_path__ + "img/backspace.1607fd8e.svg";